import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import API from '@resi-media/api-types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@mediaId/cues`,
    responseSchema: API.Central.V3.ContentDestinations.Cues.Get.List,
    params: {} as { mediaId: string },
    query: {} as {
      canISetCues?: number;
    },
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@mediaId/cues`,
    params: {} as { mediaId: string },
    request: {} as API.Central.V3.ContentDestinations.Cues.Post.Request,
    method: HTTP_METHODS.POST,
  },
};

export const id = {
  [HTTP_METHODS.PATCH]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@mediaId/cues/@id`,
    params: {} as { id: string; mediaId: string },
    request: {} as API.Central.V3.ContentDestinations.Cues.Patch.Request,
    method: HTTP_METHODS.PATCH,
  },
  [HTTP_METHODS.DELETE]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@mediaId/cues/@id`,
    params: {} as { id: string; mediaId: string },
    method: HTTP_METHODS.DELETE,
  },
};
